import { render, staticRenderFns } from "./phoneLoginForm.vue?vue&type=template&id=aede7f18&scoped=true&"
import script from "./phoneLoginForm.vue?vue&type=script&lang=js&"
export * from "./phoneLoginForm.vue?vue&type=script&lang=js&"
import style0 from "./phoneLoginForm.vue?vue&type=style&index=0&id=aede7f18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aede7f18",
  null
  
)

export default component.exports